<template>
  <v-card-text>
    <v-row>
      <v-col cols="12" sm="12" md="4">
        <v-card class="pa-4">
          <h3>Duração</h3>
          <div
            v-if="item.asus.booking_policy.period.min"
            v-html="
              $tc(
                `bookingPolicy.period.min_${item.asus.periodicity.type}`,
                item.asus.booking_policy.period.min,
                { min: item.asus.booking_policy.period.min }
              )
            "
          ></div>
          <div
            v-if="item.asus.booking_policy.period.max"
            v-html="
              $tc(
                `bookingPolicy.period.max_${item.asus.periodicity.type}`,
                item.asus.booking_policy.period.max,
                { max: item.asus.booking_policy.period.max }
              )
            "
          ></div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-card class="pa-4">
          <h3>Periodicidade</h3>
          <div
            v-if="item.asus.periodicity"
            v-html="
              $tc(
                `bookingPolicy.period.unique_${item.asus.periodicity.type}`,
                item.asus.periodicity.value,
                { unique: item.asus.periodicity.value }
              )
            "
          ></div>
        </v-card>
      </v-col>
      <v-col v-if="item.asus.formula.base.includes('I')" cols="12" sm="12" md="4">
        <v-card class="pa-4">
          <h3>Inserções</h3>
          <div v-if="insertionsOptions" v-html="insertionsOptions"></div>
          <template v-if="!insertionsOptions">
            <div
              v-if="item.asus.booking_policy.insertions.min"
              v-html="
                $tc(
                  `bookingPolicy.insertions.min`,
                  item.asus.booking_policy.insertions.min,
                  {
                    min: item.asus.booking_policy.insertions.min,
                    label: item.asus.custom_messages.msg_insertions,
                  }
                )
              "
            ></div>
            <div
              v-if="item.asus.booking_policy.insertions.max"
              v-html="
                $tc(
                  `bookingPolicy.insertions.max`,
                  item.asus.booking_policy.insertions.max,
                  {
                    max: item.asus.booking_policy.insertions.max,
                    label: item.asus.custom_messages.msg_insertions,
                  }
                )
              "
            ></div>
          </template>
        </v-card>
      </v-col>
      <v-col v-if="item.asus.formula.base.includes('Q')" cols="12" sm="12" md="4">
        <v-card class="pa-4">
          <h3>Quantidade</h3>
          <div
            v-if="item.asus.booking_policy.quantity.options"
            v-html="
              $tc(
                `bookingPolicy.quantity.max`,
                item.asus.booking_policy.quantity.max,
                {
                  min: item.asus.booking_policy.quantity.max,
                  label: item.asus.custom_messages.msg_quantity,
                }
              )
            "
          ></div>
          <template v-else>
            <div
              v-if="item.asus.booking_policy.quantity.min"
              v-html="
                $tc(
                  `bookingPolicy.quantity.min`,
                  item.asus.booking_policy.quantity.min,
                  {
                    min: item.asus.booking_policy.quantity.min,
                    label: item.asus.custom_messages.msg_quantity,
                  }
                )
              "
            ></div>
            <div
              v-if="item.asus.booking_policy.quantity.max"
              v-html="
                $tc(
                  `bookingPolicy.quantity.max`,
                  item.asus.booking_policy.quantity.max,
                  {
                    max: item.asus.booking_policy.quantity.max,
                    label: item.asus.custom_messages.msg_quantity,
                  }
                )
              "
            ></div>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-card class="pa-4">
          <h3>Prazos</h3>
          <div
            v-if="item.asus.booking_policy.reservation_period.min"
            v-html="
              $tc(
                `bookingPolicy.reservation.min`,
                item.asus.booking_policy.reservation_period.min,
                { count: item.asus.booking_policy.reservation_period.min }
              )
            "
          ></div>
          <div
            v-if="item.asus.booking_policy.reservation_period.max"
            v-html="
              $tc(
                `bookingPolicy.reservation.max`,
                item.asus.booking_policy.reservation_period.max,
                { count: item.asus.booking_policy.reservation_period.max }
              )
            "
          ></div>
          <div v-html="$t(`bookingPolicy.reservation.payment`)"></div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card class="pa-4">
          <h3>Políticas Comerciais</h3>
          <div
            v-html="
              $t(`bookingPolicy.commercial.investment.min`, minPrice, {
                value: minPrice,
              })
            "
          ></div>
          <div
            v-for="(ssu, i) in ssus"
            :key="i"
            v-html="$t(`bookingPolicy.commercial.required_${ssu}`)"
          ></div>
          <div
            v-if="item.asus.booking_policy.reservation_period.min"
            v-html="
              $tc(
                `bookingPolicy.commercial.cancel.min`,
                item.asus.booking_policy.reservation_period.min,
                { count: item.asus.booking_policy.reservation_period.min }
              )
            "
          ></div>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>
</template>
<script>

export default {
  props: {
    item: Object,
  },
  computed: {
    insertionsOptions() {
      if (
        this.item.asus.booking_policy.insertions.options &&
        this.item.asus.booking_policy.insertions.options.length
      ) {
        let options = JSON.parse(
          JSON.stringify(this.item.asus.booking_policy.insertions.options)
        );
        let last = options.pop();
        console.log(options);
        let label = this.item.asus.custom_messages.msg_insertions
          ? " " + this.item.asus.custom_messages.msg_insertions
          : "";
        // return this.item.asus.bookingPolicy.insertions.options;
        return options.length > 0
          ? this.$t("bookingPolicy.insertions.options") +
              " " +
              options.join(", ") +
              " " +
              this.$t("common.and") +
              " " +
              last +
              label
          : this.$t("bookingPolicy.insertions.options") + " " + last + label;
        // let res = []
        // this.item.asus.bookingPolicy.insertions.options.forEach((option) => {
        //   console.log('option', option)
        //   res.push(moment(option, 'e').format('ddd'))
        // })
        // return res
      }
      return false;
    },
    minPrice() {
      let price = this.item.asus.private_pricing_info.unity_price * this.item.asus.private_pricing_info.markup * ( this.item.asus.private_pricing_info > 0 ?  this.item.asus.private_pricing_info/100 : 1);
      if (this.item.asus.formula.base.includes("I"))
        price =
          price *
          this.item.asus.booking_policy.insertions.min *
          this.item.asus.booking_policy.period.min;
      if (this.item.asus.formula.base.includes("Q"))
        price =
          price *
          this.item.asus.booking_policy.quantity.min *
          this.item.asus.booking_policy.quantity.min;

      return this.$n(price, "currency");
    },
    ssus() {
      let res = [];
      for (let key in this.item.asus.providers) {
        if (
          this.item.asus.providers[key].required &&
          !res.includes(this.item.asus.providers[key].type)
        ) {
          res.push(this.item.asus.providers[key].type);
        }
      }
      return res;
    },
  },
};
</script>